module.exports = __webpack_public_path__ + "static/assets/c74353e50fadca255bf39786b9ab0b0c.svg";